<template>
     <v-card :class="color" dark>
              <v-card-text style="height: 110px;" class="text-center">
                {{label}}
                  <div class="text-gold text-shadow">
                        <v-btn fab class="ma-1 _numbtn"><span class="text-h5" style="color: #fff;">{{NUM[0]}}</span></v-btn>
                        <v-btn fab class="ma-1 _numbtn"><span class="text-h5" style="color: #fff;">{{NUM[1]}}</span></v-btn> 
                        <v-btn fab class="ma-1 _numbtn"><span class="text-h5" style="color: #fff;">{{NUM[2]}}</span></v-btn> 
                        <v-btn fab class="ma-1 _numbtn"><span class="text-h5" style="color: #fff;">{{NUM[3]}}</span></v-btn> 
                   </div>
                </v-card-text>
            </v-card>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "secondary"
    },
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    data: {
      type: String,
      default: ''
    },
    sup: {
      type: String,
      default: ''
    }
  },
  computed:{
    NUM(){
        var n = this.data.split(' - ')
        return n
    }
  }
}
</script>